import { Modal } from "@smart/itops-sb-design-system-dom";

export type DeleteLinkProps = {
  deleteModal: [boolean, (v: boolean) => void];
  update: () => Promise<void>;
  onReset: () => void;
  loading?: boolean;
};

export const DeleteLinkModal = ({
  deleteModal,
  update,
  onReset,
  loading,
}: DeleteLinkProps) => (
  <Modal
    header={{
      text: "Delete Link",
      icon: "solidTrashCan",
      iconBgColor: "bg-orange-200",
    }}
    open={deleteModal[0]}
    footer={{
      buttons: [
        {
          text: "Cancel",
          type: "reset",
          variant: "secondarySubtle",
          disabled: loading,
          onClick: onReset,
        },
        {
          text: "Delete Link",
          type: "submit",
          variant: "destructiveDefault",
          disabled: loading,
          onClick: update,
        },
      ],
    }}
    closeOptions={{
      escapeKey: false,
      clickOutside: false,
    }}
    loading={loading}
  >
    <p>
      Deleting this link will prevent clients from being able to access the
      form.
    </p>
    <p>Are you sure you want to delete it?</p>
  </Modal>
);
